/**
 * Whether the notifications stream can vouch for what it pushes. True once the stream has been
 * down past its grace period, until a connection opens again.
 */

import { atom } from 'jotai';

import { type StreamInput, StreamInputKind } from '@/types/notifications';

export const liveStatusDownAtom = atom(false);

/** What the notifications stream says about itself. */
export const liveStatusStreamAtom = atom(null, (_get, set, input: StreamInput): void => {
    switch (input.kind) {
        case StreamInputKind.Down:
            set(liveStatusDownAtom, true);
            break;
        case StreamInputKind.Reopened:
            set(liveStatusDownAtom, false);
            break;
        case StreamInputKind.Frame:
            break;
    }
});
